"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _constants = require("../constants");
const useResetOnClose = (_ref, afterReset) => {
  let {
    context,
    templates,
    activePageName
  } = _ref;
  const {
    isOpen
  } = context;
  (0, _react.useEffect)(() => {
    return () => {
      if (!isOpen && activePageName !== _constants.PAGES.FORM) {
        resetContext({
          ...context,
          templates
        });
        afterReset();
      }
    };
  });
};
const resetContext = _ref2 => {
  let {
    setReportTitle,
    setCurrentType,
    setCurrentFormat,
    setIsTitleEdited,
    setReportId,
    setReportUrl,
    templates
  } = _ref2;
  const {
    type: initialType,
    title: initialTitle,
    formats: initialFormats
  } = templates[0];
  setReportTitle(initialTitle);
  setCurrentType(initialType);
  setCurrentFormat(initialFormats[0]);
  setIsTitleEdited(false);
  setReportId(null);
  setReportUrl(null);
};
var _default = exports.default = useResetOnClose;